/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetOnboardingRequestById200ResponseOrganizationUsersInner
 */
export interface GetOnboardingRequestById200ResponseOrganizationUsersInner {
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseOrganizationUsersInner
     */
    'userMailAddress'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseOrganizationUsersInner
     */
    'userName'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOnboardingRequestById200ResponseOrganizationUsersInner
     */
    'userPrivilege'?: GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum;
}

export const GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum = {
    bookkeeper: 'BOOKKEEPER',
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER'
} as const;

export type GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum = typeof GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum[keyof typeof GetOnboardingRequestById200ResponseOrganizationUsersInnerUserPrivilegeEnum];


